import { FormTab, Datagrid, AutocompleteInput, List, TextField, Edit, Filter, Create,TextInput } from "ra-ui-materialui";
import { useState, useCallback, useEffect } from "react";
import {
    useNotify,
    useRedirect,
    useMutation,
    TabbedForm
} from "react-admin";
import { TabsUseStyles } from "../App";
import { PostBulkActionButtonsPermision, CustomToolbarPermissions } from "./utils";
import { required } from "ra-core";
import { getActivityType, getActivityTypeValue, getServiceType } from "../services/master-tables.service";
import { ActivityTypeValueInput } from "../components/ActivityTypeValueInput";

const validateServicePackage = (values) => {
    const errors = {};
    if (!values.serviceTypeId) {
        errors.serviceTypeId = 'Requerido';
    }
    if (!values.activityTypeId) {
        errors.activityTypeId = 'Requerido';
    }
    if (!values.subtypeActivityId) {
        errors.subtypeActivityId = 'Requerido';
    }

    return errors
}

export const ServicePackageList = props => {

    

    return (
        <List bulkActionButtons={props?.permissions?.servicePackages?.delete ? <PostBulkActionButtonsPermision perm="servicePackages.delete" /> : false} exporter={false} filters={<ServicesPackagesFilter />} {...props}>
            <Datagrid rowClick="edit" isRowSelectable={record => props?.permissions?.servicePackages?.delete}>
                <TextField label="Id" source="id" />
                <TextField label="Nombre" source="name" />
                <TextField label="Tipo de Servicio" source="serviceTypeName" />
                <TextField label="Tipología" source="activityTypeName" />
                <TextField label="SubTipología" source="subtypeActivityName" />
                <TextField label="Número de sesiones semanales" source="numberOfSessions" />
            </Datagrid>
        </List>
    );
}


export const ServicePackageEdit = (props) => {

    return (
        <Edit title={<ServicePackageTitle />} mutationMode="pessimistic" {...props} transform={transformServicePackageEdit}>
            {ServicePackageForm(props, 'edit')}
        </Edit>
    )
};

const ServicePackageTitle = ({ record }) => {
    return <span>Cliente {record ? `${record.name}` : ''}</span>;
};


export const ServicePackageCreate = (props) => {

    return (
        <Create mutationMode="pessimistic" {...props}>
            {ServicePackageForm(props)}
        </Create>
    )
};

const ServicePackageForm = (props, mode = 'create') => {

    const [activityType, setactivityType] = useState();
    const [serviceTypes, setServiceTypes] = useState();

     useEffect(() => {
             getActivityType().then(
                 res => {
                     setactivityType(res?.elements);
                 }
             )             
             getServiceType().then(
                 res => {
                     setServiceTypes(res?.elements);
                 }
             )
         }, []);


    const classes = TabsUseStyles();

    const redirect = useRedirect();
    const notify = useNotify()

    const [mutate] = useMutation();
    
    const save = useCallback(
        async (values) => {
            try {
                const res = await mutate({
                    type: mode === 'create' ? 'create' : 'update',
                    resource: 'servicePackages',
                    payload: { data: mode === 'create' ? transformServicePackageCreate(values) : transformServicePackageEdit(values) },
                }, { returnPromise: true });
                notify(`ra.notification.${mode === 'create' ? 'created' : 'updated_item'}`)
                if (mode === 'create') {
                    redirect('edit', props.basePath, res.data.id, res.data)
                } else {
                    redirect('list', props.basePath)
                }
            } catch (error) {
                if (error.error && error.error.code === 4002) {
                    notify(error.error.message, 'error')
                    return {
                        password: error.error.message
                    };
                }
                if (error.error && error.error.code === 4003) {
                    return {
                        name: error.error.message
                    };
                }
                if (error.error && error.error.code === 4001) {
                    return {
                        email: error.error.message
                    };
                }
                notify('ra.notification.http_error', 'warning')
            }
        },
        [mutate, mode, notify, props.basePath, redirect],
    );

    return (
        <TabbedForm classes={classes} save={save} validate={validateServicePackage} toolbar={<CustomToolbarPermissions perm="servicePackages.delete" />}>
            <FormTab label="Datos Generales" contentClassName="tab-container">
                <TextInput label="Nombre" source="name" validate={[required()]} />
                <TextInput label="Número de sesiones semanales" source="numberOfSessions" validate={[required()]} />
                {
                    serviceTypes ?
                    <AutocompleteInput
                    label="Tipo de servicio"
                            source="serviceTypeId"
                            choices={serviceTypes}
                            optionText="value"
                            optionValue="id"
                            options={{ InputProps: { autoComplete: 'off' } }}
                            resettable={true}
                            validate={[required()]}

                            />
                            : null
                }
                {
                    activityType ?
                        <AutocompleteInput
                            label="Tipología"
                            source="activityTypeId"
                            choices={activityType}
                            optionText="value"
                            optionValue="id"
                            options={{ InputProps: { autoComplete: 'off' } }}
                            resettable={true}
                            validate={[required()]}
                        />
                        : null
                }
                {/* {
                    activityTypeValue ?
                        <AutocompleteInput
                            label="SubTipología"
                            source="subtypeActivityId"
                            choices={activityTypeValue}
                            optionText="value"
                            optionValue="id"
                            options={{ InputProps: { autoComplete: 'off' } }}
                            resettable={true}
                            validate={[required()]}
                        />
                        : null
                } */}
                <ActivityTypeValueInput 
                    source="subtypeActivityId"
                    type="servicePackage"
                    isDisabled={false}
                />
            </FormTab>            
        </TabbedForm>
    )
}
const ServicesPackagesFilter = (props) => {

    const [activityType, setactivityType] = useState();
    const [activityTypeValue, setactivityTypeValue] = useState();
    const [serviceTypes, setServiceTypes] = useState();

     useEffect(() => {
             getActivityType().then(
                 res => {
                     setactivityType(res?.elements);
                 }
             )
             getActivityTypeValue().then(
                 res => {
                     setactivityTypeValue(res?.elements);
                 }
             )
             getServiceType().then(
                 res => {
                     setServiceTypes(res?.elements);
                 }
             )
         }, []);
         
    return (
        <Filter {...props}>
            {
                serviceTypes ?
                    <AutocompleteInput
                        label="Tipo de servicio"
                        source="serviceTypeId"
                        choices={serviceTypes}
                        optionText="value"
                        optionValue="id"
                        options={{ InputProps: { autoComplete: 'off' } }}
                        resettable={true}
                    />
                    : null
            }
            {
                activityType ?
                    <AutocompleteInput
                        label="Tipología"
                        source="activityTypeId"
                        choices={activityType}
                        optionText="value"
                        optionValue="id"
                        options={{ InputProps: { autoComplete: 'off' } }}
                        resettable={true}
                    />
                    : null
            }
            {
                activityTypeValue ?
                    <AutocompleteInput
                        label="SubTipología"
                        source="subtypeActivityId"
                        choices={activityTypeValue}
                        optionText="value"
                        optionValue="id"
                        options={{ InputProps: { autoComplete: 'off' } }}
                        resettable={true}
                    />
                    : null
            }
        </Filter>
    );
}


const transformServicePackageEdit = (data) => {
    //const createTime = data.createTime ? moment(data.createTime).format('yyyy-MM-DDTHH:mm:ss') : null;
    return {
        ...data
    }
}

const transformServicePackageCreate = (data) => {
    return {
        ...data
    }
}